export default __webpack_public_path__ + "static/media/equal-nft-banner-avatar.fd448dff.png";